module.exports = __webpack_public_path__ + "img/logo5-blue-white-gold-fill-sm.2c75d224.png";